import { ModelBase, observable } from "@shoothill/core";
import { action } from "mobx";
export class RDDV2StatusModel extends ModelBase<RDDV2StatusModel> {
    public static readonly DEFAULT_RDDV2_ID = "";

    @observable
    public rddV2Id: string = RDDV2StatusModel.DEFAULT_RDDV2_ID;

    @action
    public fromDto(dto: RDDV2StatusResponseDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else if (key === "rddV2Items") {
                    // Do nothing.
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    @action
    toDto(model: RDDV2StatusModel): void {}
}

export interface RDDV2StatusResponseDTO {}

export interface RDDV2StatusRequestDTO {
    id: string | null;
}
